export const safeParseUtm = (value: any): Record<string, any> => {
  if (!value) return {};
  if (typeof value === 'object') return value;
  if (typeof value !== 'string') return {};

  const trimmed = value.trim();

  if (!trimmed) return {};

  if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
    try {
      return JSON.parse(trimmed);
    } catch {
      return {};
    }
  }

  return {};
};

export const handleGetutm = (application: any) => {
  const utm =
    localStorage.getItem('utm-saved-param') ||
    localStorage.getItem('utmUrlState') ||
    localStorage.getItem('redirectUrlParams') ||
    localStorage.getItem('urlParams');

  const finalUtm = {
    ...safeParseUtm(application?.payload?.initialInfo?.utm || '{}'),
    ...safeParseUtm(utm || '{}'),
  };
  // const finalUtm: any = { utm_campaign: 'test', utm_source: 'test', trackingId: 'test' };
  const trackingId: any = localStorage.getItem('tracking_id') || finalUtm?.trackingId;
  return Object.entries({ ...finalUtm, trackingId } || {})
    .map(([key, value]: any) => {
      return `${key}=${value}`;
    })
    ?.join('&');
};

export const getTrackingId = (application: any) => {
  const utm =
    localStorage.getItem('utm-saved-param') ||
    localStorage.getItem('utmUrlState') ||
    localStorage.getItem('redirectUrlParams') ||
    localStorage.getItem('urlParams');

  const finalUtm = {
    ...safeParseUtm(utm || '{}'),
    ...safeParseUtm(application?.payload?.initialInfo?.utm || '{}'),
  };
  // const finalUtm: any = { utm_campaign: 'test', utm_source: 'test', trackingId: 'test' };
  return finalUtm?.trackingId || localStorage.getItem('tracking_id');
};
